<div class="estimate-statistics-container" [formGroup]="estimateStatisticsForm">
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_STATUS' | translate  }}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('status')?.value}}</div>
    </div>
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_SUBMITTED' | translate}}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('submitted')?.value}}</div>
    </div>
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_CREATED_BY'| translate}}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('createdBy')?.value}}</div>
    </div>
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_CREATION_DATE' | translate}}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('creationDate')?.value | multilingualDate: 'dateTime'}}</div>
    </div>
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_MODIFIED_DATE' | translate}}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('modifiedDate')?.value | multilingualDate: 'dateTime'}}</div>
    </div>
     <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_MODIFIED_BY' | translate}}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('modifiedBy')?.value}}</div>
    </div>
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_LAST_UPLOADED_TO_SERVER' | translate}}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('lastUploadedToServer')?.value | multilingualDate: 'dateTime'}}</div>
    </div>
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_LAST_DATA_SYNCHRONIZATION' | translate}}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('lastDataSynchronization')?.value | multilingualDate: 'dateTime'}}</div>
    </div>
     <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_LAST_PROPOSAL_GENERATED' | translate}}</label>
        </div>
        <div class="col-sm-4">{{estimateStatisticsForm.get('lastProposalGenerated')?.value  | multilingualDate: 'dateTime'}}</div>
    </div>
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_STATISTICS_PROPOSAL_LINK' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <a href="{{proposalLink}}" target="_blank" class="custom-anchor">
                {{proposalId}}
            </a>
        </div>
    </div>
    <div class="row row-height">
        <div class="col-sm-3">
            <label>{{'OPPORTUNITY_LINK' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <a href="{{opportunityLink}}" target="_blank" class="custom-anchor">
                {{opportunityId}}
            </a>
        </div>
    </div>
</div>